import React from "react";

const MedicalCentreIcon = () => {
  return (
    <svg
      width="38"
      height="39"
      viewBox="0 0 38 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.875 29.8225H22.125V24.1773H28.375V18.5322H22.125V12.887H15.875V18.5322H9.625V24.1773H15.875V29.8225ZM0.25 38.2902V12.887L19 0.163925L37.75 12.887V38.2902H0.25ZM4 34.9031H34V14.5805L19 4.41925L4 14.5805V34.9031Z"
        fill="#03579E"
      />
    </svg>
  );
};

export default MedicalCentreIcon;
